import { InjectedConnector } from '@web3-react/injected-connector';
import { BscConnector } from '@binance-chain/bsc-connector';
import { bscTestnetChainId } from '../contracts/contractABI';

// Injected connector (MetaMask)
export const injected = new InjectedConnector({
  supportedChainIds: [bscTestnetChainId]
});

// BSC connector (Binance Chain Wallet)
export const bscConnector = new BscConnector({
  supportedChainIds: [bscTestnetChainId]
});

// Function to check if the wallet is connected to the correct network
export const checkNetwork = async (library) => {
  if (!library) return false;
  
  try {
    const network = await library.getNetwork();
    return network.chainId === bscTestnetChainId;
  } catch (error) {
    console.error('Error checking network:', error);
    return false;
  }
};

// Function to switch to BSC Testnet
export const switchToBscTestnet = async (library) => {
  if (!library || !library.provider || !library.provider.request) {
    console.error('Provider not available');
    return false;
  }
  
  try {
    await library.provider.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: `0x${bscTestnetChainId.toString(16)}` }]
    });
    return true;
  } catch (switchError) {
    // This error code indicates that the chain has not been added to MetaMask
    if (switchError.code === 4902) {
      try {
        await library.provider.request({
          method: 'wallet_addEthereumChain',
          params: [
            {
              chainId: `0x${bscTestnetChainId.toString(16)}`,
              chainName: 'Binance Smart Chain Testnet',
              nativeCurrency: {
                name: 'BNB',
                symbol: 'BNB',
                decimals: 18
              },
              rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
              blockExplorerUrls: ['https://testnet.bscscan.com/']
            }
          ]
        });
        return true;
      } catch (addError) {
        console.error('Error adding BSC Testnet to wallet:', addError);
        return false;
      }
    }
    console.error('Error switching to BSC Testnet:', switchError);
    return false;
  }
};

// Function to get wallet address in shortened format
export const shortenAddress = (address) => {
  if (!address) return '';
  return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
};
